import React from "react"
import { graphql } from "gatsby"
import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"

// Components
import Layouter from "§/src/components/sections/layouter"
import HeaderSubContent from "§/src/components/atoms/content/header-sub-content"
import TextModule from "§/src/components/atoms/content/text-module"
import RelatedProductsWithImage from "§/src/components/sections/related-products-with-image"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

// Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="application-notes"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} langReplace='applications'/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const Post = props => {
  const { t } = useTranslation()
  const cptApplicationChildrens = props?.pageContext?.cptApplicationChildrens
  cptApplicationChildrens.textModules = translateToNewFormat(
    cptApplicationChildrens.textModules
  )

  // Fix applications breadcrumbs
  // for any reasons, is correct only for plastic, and seem to be related to yoast seo
  const seo = props?.pageContext?.seo || {}
  const parentUrl = props?.pageContext?.wpParent?.node?.uri
  if(seo?.breadcrumbs[1]){
    seo.breadcrumbs[1].url = parentUrl
  }

  return (
    <Layout lang={props?.data?.lang?.translations} langReplace='applications'>
      <Breadcrumb
        wpseo={props?.pageContext?.seo?.breadcrumbs}
        base={t("Settori industriali")}
      />

      {!isEmpty(props) ? (
        <React.Suspense fallback={<LoadingFrame />}>
          <HeaderSubContent
            title={props?.pageContext?.title}
            description={cptApplicationChildrens?.subtitle}
            className="desc-gray"
          >
            <div className="d-flex gap-2">
              {props?.pageContext?.wpParent?.node?.title && (
                <UniversalLink
                  className="btn btn-sm btn-outline-dark b-light rounded-pill"
                  to={props.pageContext.wpParent.node.uri}
                >
                  {props.pageContext.wpParent.node.title}
                </UniversalLink>
              )}
            </div>
          </HeaderSubContent>

          {cptApplicationChildrens?.mainImage && (
            <RelatedProductsWithImage
              mainImage={cptApplicationChildrens?.mainImage}
              products={cptApplicationChildrens?.relatedProducts}
            />
          )}

          {cptApplicationChildrens?.textModules && (
            <div className={"bg-full py-4 g-100"}>
              {cptApplicationChildrens?.textModules &&
                cptApplicationChildrens?.textModules.map((item, index) => {
                  return (
                    <TextModule
                      key={"text-module-" + index}
                      pretitle={item?.preTitle}
                      title={item?.title}
                      content={item?.content}
                      downloadstitle={t(
                        "Scarica la nota applicativa e scopri tutti i dettagli"
                      )}
                      downloadsfiles={item?.downloads?.downloadFiles}
                      reports={item?.reports}
                      className={"bg-full py-4 py-md-5 g-100"}
                    />
                  )
                })}
            </div>
          )}

          {cptApplicationChildrens?.layouter && (
            <div className="mt-7 mt-md-9">
              <Layouter data={cptApplicationChildrens?.layouter} />
            </div>
          )}
        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default Post

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang: wpApplication(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`

const translateToNewFormat = data => {
  data = [...data]
  for (const elem of data) {
    if (elem && elem.downloadFiles) {
      elem.downloadFiles = elem.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
    if (elem && elem.downloads && elem.downloads.downloadFiles) {
      elem.downloads.downloadFiles = elem.downloads.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
  }
  return data
}
